import type { KbPage } from "@/lib/kb-api";

export type PageEditorDraft = {
  title: string;
  body: string;
  structured: Record<string, unknown>;
};

/** 深度比较普通 JSON 值（对象键序无关）。 */
function deepEqual(a: unknown, b: unknown): boolean {
  if (Object.is(a, b)) return true;
  if (typeof a !== typeof b) return false;
  if (a == null || b == null) return a === b;
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    return a.every((item, index) => deepEqual(item, b[index]));
  }
  if (typeof a === "object" && typeof b === "object" && !Array.isArray(a) && !Array.isArray(b)) {
    const aObj = a as Record<string, unknown>;
    const bObj = b as Record<string, unknown>;
    const aKeys = Object.keys(aObj);
    const bKeys = Object.keys(bObj);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key) => Object.prototype.hasOwnProperty.call(bObj, key) && deepEqual(aObj[key], bObj[key]));
  }
  return false;
}

/**
 * 页面编辑器是否有未保存改动。
 * seed：比 structured + body；普通页：比 title + body。
 */
export function isPageEditorDirty(page: KbPage, draft: PageEditorDraft): boolean {
  const serverBody = page.body ?? "";
  if (page.is_seed) {
    return draft.body !== serverBody || !deepEqual(draft.structured, page.structured ?? {});
  }
  return draft.title !== page.title || draft.body !== serverBody;
}
